import React, { Component } from 'react';
import Footer from "../components/Footer.js"
import NavBar from "../components/NavBar.js"
import DeliveryButtons from "../components/DeliveryButtons.js"
import FAQAccordion from "../components/FAQAccordion.js"

import '../css/main.css';

class ContactPage extends Component {

  render() {
    return (
        <div id="body">
          <NavBar />

          <section className="contact_section">
            <div className="section_header" style={{marginTop: '20px'}}>
              <span className="section_label">Contact Us</span>
              <h2 className="section_title">聯絡我們</h2>
            </div>

            {/* Phone CTA — Hero */}
            <div className="contact_phone_hero">
              <p className="contact_phone_subtitle">來電訂購，新鮮現做</p>
              <a href="tel:0286617800" className="contact_phone_number">
                <span className="phone_icon">&#9743;</span>
                02-8661-7800
              </a>
              <p className="contact_phone_hours">營業時間 Mon-Sun 11:30 - 22:00</p>
            </div>

            {/* Google Map */}
            <div className="contact_map_wrap">
              <iframe
                title="豆日子位置"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d903.8!2d121.5627981!3d24.9891104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abd291b7f3f5%3A0x801047d4a0696527!2sDoDay+%E8%B1%86%E6%97%A5%E5%AD%90%E8%B1%86%E8%8A%B1%E7%94%9C%E5%93%81%E5%BA%97+(%E6%9C%A8%E6%9F%B5%E5%BA%97)!5e0!3m2!1szh-TW!2stw!4v1"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>

            {/* Delivery Ordering */}
            <div className="contact_delivery_section">
              <h3 className="contact_delivery_title">外送訂餐</h3>
              <DeliveryButtons />
            </div>

            <div className="contact_info_row">
              {/* Store Info */}
              <div className="store_card">
                <img
                  className="store_card_img"
                  src={process.env.PUBLIC_URL + "/image/shop_cover.png"}
                  alt="豆日子 木柵創始店"
                />
                <div className="store_card_body">
                  <h3 className="store_card_name">木柵創始店</h3>
                  <ul className="store_card_info">
                    <li>
                      <span className="info_icon">&#9906;</span>
                      <span>台北市文山區木柵路二段149號一樓</span>
                    </li>
                    <li>
                      <span className="info_icon">&#9719;</span>
                      <span>營業時間: Mon-Sun 11:30 - 22:00</span>
                    </li>
                    <li>
                      <span className="info_icon">&#9743;</span>
                      <a href="tel:0286617800" className="store_phone_link">訂購專線: 02-8661-7800</a>
                    </li>
                    <li>
                      <span className="info_icon">&#9993;</span>
                      <span>contact@nexuni.com</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Social & FAQ */}
              <div className="store_card">
                <div className="store_card_body">
                  <h3 className="store_card_name">追蹤我們</h3>
                  <div className="social_links">
                    <a
                      href="https://www.instagram.com/doday_official/?hl=zh-tw"
                      className="social_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <img src={process.env.PUBLIC_URL + "/image/instagram.png"} alt="Instagram"/>
                    </a>
                    <a
                      href="https://www.facebook.com/pg/豆日子doday-106167927822106/posts/"
                      className="social_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <img src={process.env.PUBLIC_URL + "/image/facebook.png"} alt="Facebook"/>
                    </a>
                  </div>

                  <FAQAccordion />
                </div>
              </div>
            </div>
          </section>

          <Footer />
        </div>
    );
  }
}

export default ContactPage;
